import React from 'react';
import './system-states.css';

export type SystemStateAction = {
  label: string;
  onClick?: () => void;
  href?: string;
  variant?: 'primary' | 'outline';
};

type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actions?: SystemStateAction[];
};

const EmptyState: React.FC<EmptyStateProps> = ({ icon = '📭', title, description, actions }) => (
  <div className="sys-state">
    <div className="sys-state-icon-wrap">{icon}</div>
    <h3 className="sys-state-title">{title}</h3>
    {description && <p className="sys-state-desc">{description}</p>}
    {actions && actions.length > 0 && (
      <div className="sys-state-actions">
        {actions.map((a, i) => {
          const cls = `sys-state-btn sys-state-btn--${a.variant ?? 'outline'}`;
          return a.href
            ? <a key={i} href={a.href} className={cls}>{a.label}</a>
            : <button key={i} type="button" className={cls} onClick={a.onClick}>{a.label}</button>;
        })}
      </div>
    )}
  </div>
);

export default EmptyState;
